import { useEffect, useState, useRef, forwardRef, useImperativeHandle, useContext } from "react";
import { AuthContext } from '../../../services/authContext';
import { getUserById } from '../../../services/userService';
import { getUserMedicalQuestionnaire, getUserMedicalQuestionnaireHistory, getQuestionAnswersByUserId, getUserOrderHistory } from '../../../services/nrtService';
import { Button } from "react-bootstrap";
import PathwayBadges from "./PathwayBadges";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { byPrefixAndName } from "@awesome.me/kit-8685c875a9/icons";
import "../../../scss/components/liveChat.scss";
import MedicalQuestionnaire from "../nrtOrders/MedicalQuestionnaire";

import CreateNRTOrder from "../nrtOrders/CurrentOrders_CreateOrder";

const ChatWindowComponent = ({ chat, isActive, bringToFront, closeChat, releaseChat, toggleMinimise, isMinimised, sendMessage, messages }, ref) => {
    const [medicalQuestions, setMedicalQuestions] = useState(null);
    const [medicalQuestionnaireHistory, setMedicalQuestionnaireHistory] = useState(null);
    const [orderHistory, setOrderHistory] = useState(null);
    const [userDataQuestions, setUserDataQuestions] = useState(null);

    const [lightboxImage, setLightboxImage] = useState(null);

    const [showUserProfile, setShowUserProfile] = useState(false);

    const handleImageClick = (imageSrc) => {
        setCurrentImage(imageSrc);
        setLightboxOpen(true);
    };

    const { userProfile, userRoles } = useContext(AuthContext);

    const chatUserId = chat.userId;
    const getMedicalQuestionData = async () => {
        try {
            const medicalDataResult = await getUserMedicalQuestionnaire(chat.userId);
            const medicalHistoryResult = await getUserMedicalQuestionnaireHistory(chat.userId);
            const orderHistoryResult = await getUserOrderHistory(chat.userId);
            const userDataResult = await getQuestionAnswersByUserId(chat.userId);
            setMedicalQuestions(medicalDataResult || []);
            setMedicalQuestionnaireHistory(medicalHistoryResult || []);
            setOrderHistory(orderHistoryResult || []);
            setUserDataQuestions(userDataResult || []);
        } catch (error) {
            console.error("Error fetching medical questionnaire data:", error);
        }
    };

    useEffect(() => {
        getMedicalQuestionData();
    }, []);




    const [chatUserProfile, setChatUserProfile] = useState(null);

    const [message, setMessage] = useState("");
    const chatBodyRef = useRef(null);

    const [isChecked, setIsChecked] = useState(false);

    const [activeTab, setActiveTab] = useState('chat'); // 'chat', 'nrt', or 'medical'

    const [isOpen, setIsOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);



    const fetchUserById = async (id) => {
        try {
            const chatUserData = await getUserById(id); // Assuming this is an imported function
            setChatUserProfile(chatUserData);
        } catch (err) {
            console.error('Error fetching chat user profile data:', err);
            setChatUserProfile(null);
        }
    }

    const openUserProfile = () => {
        setShowUserProfile(prev => !prev);
    };


    useEffect(() => {
        if (chat && chat.userId) {
            fetchUserById(chat.userId); // Call the new function
        }
    }, [chat.userId]); // Trigger the effect when chat.id changes




    useEffect(() => {
        if (!isChecked) {
            setShowModal(false);
            setIsOpen(false);
        }
    }, [isChecked]);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
        setShowModal(!isOpen)
    };

    const openOrderForm = () => {
        const url = "https://bestyoucrm-prod.azurewebsites.net";
        window.open(url, "_blank", "noopener,noreferrer");
    };

    useEffect(() => {
        if (!isChecked) {
            setShowModal(false);
            setIsOpen(false);
        }
    }, [isChecked]);


    const handleSend = () => {
        if (message.trim() === "") return;
        sendMessage(message);
        setMessage("");
    };

    useImperativeHandle(ref, () => ({
        scrollToBottom: () => {
            if (chatBodyRef.current) {
                const el = chatBodyRef.current;
                el.scrollTo({
                    top: el.scrollHeight,
                    behavior: 'smooth'
                });
            }
        }

    }));

    return (
        <div className={`chatConsole component p-0 ${isMinimised ? "minimised" : ""} ${isActive ? "active" : ""}`} onMouseDown={() => bringToFront(chat.id)}>

            <div className="chatConsole__tabs d-flex justify-content-center">
                <span
                    className={activeTab === 'chat' ? 'chatConsole__tabs__tab--active' : 'chatConsole__tabs__tab'}
                    onClick={() => setActiveTab('chat')}
                >
                    Chat
                </span>
                <span
                    className={activeTab === 'userMedicalAssessment' ? 'chatConsole__tabs__tab--active mx-1' : 'chatConsole__tabs__tab mx-1'}
                    onClick={() => setActiveTab('userMedicalAssessment')}
                >
                    Client Data
                </span>
                <span
                    className={activeTab === 'nrtOrderForm' ? 'chatConsole__tabs__tab--active' : 'chatConsole__tabs__tab'}
                    onClick={() => setActiveTab('nrtOrderForm')}
                >
                    NRT Order
                </span>
            </div>
                <div className="chatWindow" style={{ display: activeTab === 'chat' ? 'block' : 'none' }}>
                    {showUserProfile && (
                        <div className="chatWindow__chatUserProfile component">
                        <p>Name: {chatUserProfile.profile.firstName + " " + chatUserProfile.profile.familyName}</p>
                        <p>Client ID: {chatUserProfile.profile.id}</p>
                        <p>Email: {chatUserProfile.email}</p>
                        <p>DOB: {chatUserProfile.profile.dateOfBirth}</p>
                        <p>Address: {chatUserProfile.profile.address}</p>
                        <p>Address Line 1: {chatUserProfile.profile.addressLine1}</p>
                        <p>Address Line 2: {chatUserProfile.profile.addressLine2}</p>
                        <p>Address Line 3: {chatUserProfile.profile.addressLine3}</p>
                        <p>Postcode: {chatUserProfile.profile.postcode}</p>
                        <p>Contact Number: {chatUserProfile.profile.contactNumber}</p>
                        <p>Service Area: {chatUserProfile.profile.serviceArea?.name}</p>
                        </div>
                    )}
                    <div className="chatWindow__header">
                        <span className="chatWindow__header__title">Chatting with: {chat.firstName} {chat.familyName} <span onClick={() => openUserProfile()} role="button"><FontAwesomeIcon icon={byPrefixAndName.fas["address-card"]} /></span><PathwayBadges smokingInformation={chatUserProfile?.smokingInformation} /></span>
                        <span className="chatWindow__header__title">
                            You are chatting as: {userProfile.nickname ? userProfile.nickname : `${userProfile.firstName} ${userProfile.familyName}`}
                        </span>

                        <div className="chatWindow__header__windowControls">

                            {isMinimised ? (
                                <span onClick={() => toggleMinimise(chat.id)} title="Maximuse">
                                    <FontAwesomeIcon icon={byPrefixAndName.fas["window-maximize"]} />
                                </span>
                            ) : (
                                <span onClick={() => toggleMinimise(chat.id)} title="Minimise">
                                    <FontAwesomeIcon icon={byPrefixAndName.fas["minus"]} />
                                </span>
                            )}
                            <span onClick={() => releaseChat(chat.id)} title="Leave Chat">
                                <FontAwesomeIcon icon={byPrefixAndName.fas["person-walking-arrow-right"]} />
                            </span>
                        </div>
                    </div>

                    {!isMinimised && (
                        <>
                            <div className="chatWindow__body">
                                <div className="chatWindow__body__chatBody" ref={chatBodyRef}>
                                    {(messages || []).map((msg, idx) => {
                                        const now = new Date();
                                        const sentDate = msg.sentAs || msg.sentAt ? new Date(msg.sentAs || msg.sentAt) : null;

                                        let formattedDate;

                                        if (!sentDate) {
                                            // No date provided, show current time only
                                            formattedDate = now.toLocaleTimeString('en-GB', {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: false,
                                                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                            });
                                        } else {
                                            const isToday =
                                                sentDate.getDate() === now.getDate() &&
                                                sentDate.getMonth() === now.getMonth() &&
                                                sentDate.getFullYear() === now.getFullYear();

                                            const formattedTime = sentDate.toLocaleTimeString('en-GB', {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: false,
                                                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                            });

                                            formattedDate = isToday
                                                ? `Today, ${formattedTime}`
                                                : `${sentDate.getDate().toString().padStart(2, '0')} ${sentDate.toLocaleString('en-GB', { month: 'short' })} ${sentDate.getFullYear()}, ${formattedTime}`;
                                        }

                                        return (
                                            <div key={idx} className={`chatWindow__body__chatBody__message ${msg.senderType || ''} ${msg.user || ''}`}>
                                                {msg.messageType === "image" || msg.type === "Image" ? (
                                                    <>
                                                        <span className="chatWindow__body__chatBody__message__viewImage text-white text-center size-18"
                                                            onClick={() => setLightboxImage(msg.message)}
                                                        >
                                                            <span><FontAwesomeIcon icon={byPrefixAndName.fas["up-right-and-down-left-from-center"]} /></span>
                                                            <span>View Image</span>
                                                        </span>
                                                        <img src={msg.message} className="img-fluid" alt="chat" />

                                                    </>
                                                ) : (
                                                    <span className="d-block size-16">{msg.message}</span>
                                                )}
                                                <span className="size-11 d-block">Sent at: {formattedDate}</span>
                                            </div>
                                        );
                                    })}

                                </div>
                            </div>

                            <div className="chatWindow__footer">
                                <div className="chatWindow__footer__messageBody">
                                    <textarea
                                        placeholder="Start typing..."
                                        className="chatWindow__footer__messageBody__text"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                    />
                                </div>
                                <div className="chatWindow__footer__messageSend">
                                    <Button variant="danger" onClick={() => closeChat(chat.id)}>Resolve</Button>
                                    <Button variant="primary" onClick={handleSend}>Send</Button>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <div className="nrtOrderForm" style={{ display: activeTab === 'nrtOrderForm' ? 'block' : 'none' }}>
                    <div className="nrtOrderForm__inner pt-4">
                        {userRoles.includes('NRT Approval') ? (
                            !medicalQuestions || Object.keys(medicalQuestions).length === 0 ? (
                                <>
                                    <p className="text-center">No medical questionnaire data found</p>
                                </>
                            ) : (
                                <>
                                    <p>Before you create a new NRT Order for this client, please check that you have:</p>
                                    <ul>
                                        <li>Requested and approved photo proof of a valid UK ID</li>
                                        <li>Agreed the user is eligible for NRT based on their medical assessment</li>
                                    </ul>
                                    <div className="form-check my-2 d-flex align-items-start">
                                        <input
                                            type="checkbox"
                                            id="agreeCheckbox"
                                            className="form-check-input mt-1"
                                            checked={isChecked}
                                            onChange={
                                                (e) => {
                                                    setIsChecked(e.target.checked);
                                                }}
                                        />
                                        <label className="form-check-label ms-2" htmlFor="agreeCheckbox">
                                            I confirm
                                        </label>
                                    </div>


                                    <div className="text-center my-3">
                                        <button
                                            className={`btn ${showModal ? 'btn-secondary' : 'btn-primary'}`}
                                            onClick={toggleMenu}
                                            disabled={!isChecked}
                                        >
                                            {showModal ? (<span>Close</span>) : (<span>Log NRT Order</span>)}
                                        </button>

                                    </div>

                                    <div className="text-center my-3">
                                        <button
                                            className="btn btn-primary"
                                            onClick={openOrderForm}
                                            disabled={!isChecked}
                                        >
                                            <span>Open Order Form</span>
                                        </button>

                                    </div>

                                    <CreateNRTOrder
                                        chatUserProfile={chatUserProfile.profile}
                                        chatUserID={chatUserId}
                                        show={showModal}
                                        handleClose={() => setShowModal(false)}
                                    />
                                </>
                            )

                        ) : (
                            <p className="text-center">You do not have permission to create NRT orders, see admin.</p>
                        )}


                    </div>
                </div>

                <div className="userMedicalAssessment" style={{ display: activeTab === 'userMedicalAssessment' ? 'block' : 'none' }}>
                    <div className="userMedicalAssessment__inner pt-4">
                        <div>
                            {userRoles.includes('NRT Approval') ? (
                                medicalQuestions === null ? (
                                    <>
                                        <p className="text-center">No medical questionnaire data found</p>
                                    </>
                                ) : (
                                    <MedicalQuestionnaire orderHistory={orderHistory} medicalData={medicalQuestions} medicalHistory={medicalQuestionnaireHistory} userData={userDataQuestions} chatUserProfile={chatUserProfile} />
                                )
                            ) : (
                                <p className="text-center">You do not have permission to create NRT orders, see admin.</p>
                            )}

                        </div>
                    </div>
                </div>


            {lightboxImage && (
                <div
                    className="lightbox"
                    onClick={() => setLightboxImage(null)}
                >
                    <img
                        src={lightboxImage}
                    />
                </div>
            )}

        </div>
    );
};

const ChatWindow = forwardRef(ChatWindowComponent);

export default ChatWindow;
